// extracted by mini-css-extract-plugin
module.exports = {"inspector":"styles_inspector__FatDQ","customClass":"styles_customClass__1Fb7s","form__hint":"styles_form__hint__1naTO"};